import { Button, Stack } from "@mui/material"
import { GridColDef } from "@mui/x-data-grid"

export const getColumns = (
  handleDialogOpen: (row: any) => void,
): GridColDef[] => {
  const columns: GridColDef[] = [
    { field: "id", headerName: "ID", minWidth: 90, sortable: false },
    {
      field: "level3Name",
      headerName: "Catogery 3",
      minWidth: 180,
      sortable: true,
      flex: 1,
    },
    {
      field: "level2Name",
      headerName: "Category 2",
      minWidth: 180,
      sortable: true,
      flex: 1,
    },
    {
      field: "level1Name",
      headerName: "Category",
      minWidth: 180,
      sortable: true,
      flex: 1,
    },

    {
      field: "source",
      headerName: "Source",
      minWidth: 180,
      flex: 1,
      sortable: false,
    },
    {
      field: "createdAt",
      headerName: "Created on",
      minWidth: 180,
      sortable: true,
      flex: 1,
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      minWidth: 180,
      sortable: true,
      flex: 1,
    },
    {
      field: "action",
      headerName: "Action",
      width: 200,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <Stack direction="row" gap={1}>
            <Button
              size="small"
              variant="contained"
              onClick={() => handleDialogOpen(row)}
            >
              Edit
            </Button>
          </Stack>
        )
      },
    },
  ]

  return columns
}

export const initialColumnsState = {
  columns: {
    columnVisibilityModel: {
      id: false,
    },
  },
}
